import React from 'react';
import { makeStyles, rgba } from 'react-scale/components/design-system/styles';
import { INamedEntityRecognitionAnnotation } from './namedEntityRecognitionAnnotations';
import {
  INamedEntityRecognitionLabel,
  getLabelColorPalette,
  IColorMap,
} from './namedEntityRecognitionLabels';
/* eslint-disable restrict-imports/restrict-imports */
import { Popover } from '@material-ui/core';

interface INERAnnotationClumpLabelProps {
  annotations: INamedEntityRecognitionAnnotation[];
  labels: INamedEntityRecognitionLabel[];
  labelColormap: IColorMap;
  clientBox: { top: number; left: number; height: number; width: number };

  hoverAnnotationById: (annotationId: string) => void;
  unHoverAnnotationById: (annotationId: string) => void;
  focusAnnotationById: (annotationId: string) => void;
}

const NERAnnotationClumpLabel: React.ForwardRefRenderFunction<
  HTMLDivElement,
  INERAnnotationClumpLabelProps
> = (
  {
    annotations,
    labels,
    labelColormap,
    clientBox,
    hoverAnnotationById,
    unHoverAnnotationById,
    focusAnnotationById,
  },
  containerRef: $FIXME,
) => {
  const classes = useNERAnnotationClumpLabelStyles();
  const [showPopover, setShowPopover] = React.useState<boolean>(false);

  return (
    <div>
      {containerRef.current && (
        <Popover
          anchorEl={containerRef.current}
          anchorOrigin={{ horizontal: clientBox.left, vertical: clientBox.top - 2 }}
          transformOrigin={{
            horizontal: 'right',
            vertical: 'bottom',
          }}
          open={showPopover}
          onClose={() => setShowPopover(false)}
        >
          <div className={classes.clumpMenu}>
            {annotations.map((annotation, idx) => {
              const labelColorPalette = getLabelColorPalette(labels[idx].name, labelColormap);
              return (
                <div
                  key={annotation.id}
                  className={classes.clumpMenuItem}
                  onClick={() => {
                    focusAnnotationById(annotation.id);
                    setShowPopover(false);
                  }}
                  onMouseEnter={() => hoverAnnotationById(annotation.id)}
                  onMouseLeave={() => unHoverAnnotationById(annotation.id)}
                >
                  <div
                    className={classes.clumpMenuItemIcon}
                    style={{
                      backgroundColor: labelColorPalette.listItemBackground,
                    }}
                  />
                  {labels[idx].display_name ?? labels[idx].name}
                </div>
              );
            })}
          </div>
        </Popover>
      )}
      <div
        className={classes.clumpLabel}
        onClick={() => setShowPopover(true)}
        style={{
          top: clientBox.top - 11,
          left: clientBox.left,
        }}
      >
        {annotations.length} labels
      </div>
    </div>
  );
};

const useNERAnnotationClumpLabelStyles = makeStyles({
  clumpLabel: {
    position: 'absolute',
    color: rgba('#000', 0.3),
    backgroundColor: '#fff',
    fontSize: 11,
    fontWeight: 500,
    lineHeight: '11px',
    zIndex: 2,
    cursor: 'pointer',
    userSelect: 'none',
  },
  clumpMenu: {
    minWidth: 240,
  },
  clumpMenuItem: {
    display: 'flex',
    alignItems: 'center',
    padding: 10,
    fontSize: 14,
    lineHeight: '20px',
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: '#F8F8F8',
    },
  },
  clumpMenuItemIcon: {
    display: 'inline-flex',
    width: 16,
    height: 16,
    marginInlineEnd: '8px',
    borderRadius: 4,
  },
});

export default React.forwardRef(NERAnnotationClumpLabel);
